import { useEffect } from 'react';

import { useFormik } from 'formik';

import {
  ILongContractRequestsData,
  ILongTermContractModel,
} from '@pharmaplan/common';

import { stub } from '@pharmaplan/common/helpers/utils';

import useViewEditContract from '../workshift/useViewEditContract';

const useLongTermFormikDetails = (
  event: Array<ILongContractRequestsData>,
  longTermContract: ILongTermContractModel,
  proposedAllowance?:string,
) => {
  const { intervalsInitial } = useViewEditContract();
  const { weekDayPaidHourlyRate, weekendPaidHourlyRate, allowanceNotes } = longTermContract ?? {};

  const formik = useFormik({
    initialValues: {
      allowanceNotes,
      weekDayPaidHourlyRate,
      weekendPaidHourlyRate,
      proposedAllowance,
    },
    enableReinitialize: true,
    onSubmit: stub,
  });

  useEffect(() => {
    if (event) {
      formik.setValues({
        allowanceNotes,
        weekDayPaidHourlyRate,
        weekendPaidHourlyRate,
        proposedAllowance,
        ...intervalsInitial(event),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);

  return { formik };
};

export default useLongTermFormikDetails;
